import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

const SEGMENT_WIDTH = '230px';

export const SectionContent = styled.div`
  position: relative;

  @media (max-width: 991px) {
    border: 0;
  }
  @media (min-width: 992px) {
    padding: 0 30px;
    position: relative;
    width: 100%;
  }
`;

export const RecordingStateWrapper = styled.div`
  padding-top: 30px !important;
  margin-top: 30px !important;
`;

export const CenterAlignedContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const RecordingsPageContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const RecordingsListContainer = styled.div<{ isLoading: boolean; noSidebar: boolean }>`
  display: flex;
  flex-direction: column;
  width: ${(props) =>
    props.isLoading || props.noSidebar ? '100%' : `calc(100% - ${SEGMENT_WIDTH})`};
`;

export const HorizontalContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SegmentSidebarContainer = styled.div`
  width: ${SEGMENT_WIDTH};
  flex-shrink: 0;
`;

export const Spacer = styled.div`
  padding-top: ${tokens.spacer.x3};
`;

export const EmptyStateWrapper = styled.div`
  display: flex;
  padding: ${tokens.spacer.x4} 50px;
  margin-bottom: ${tokens.spacer.x6};
`;
